import type { ReactNode } from "react";
import { cn } from "./cn";

export type BadgeTone = "success" | "warning" | "danger" | "info" | "muted";

export interface BadgeProps {
  tone?: BadgeTone;
  children: ReactNode;
}

/** Short status text. Not clickable by default; color is never the only signal. */
export function Badge({ tone, children }: BadgeProps) {
  return <span className={cn("status-badge", tone)}>{children}</span>;
}
